import { Button } from "@/components/ui/button/button";
import {
  BwFounderAvatarGroup,
  BwPlaceDark,
  BwPlaceLight,
} from "@/components/ui/icons";
import ThemeIcon from "@/components/ui/icons/theme-icon";
import { formatLaunchDate } from "@/features/shared/presale";
import { PRESALE_FOUNDERS } from "../_libs/presale-content";
import type { PresaleView } from "../_types";

type PresaleHeroProps = {
  view: PresaleView;
  onReferClick: () => void;
};

export function PresaleHero({ view, onReferClick }: PresaleHeroProps) {
  return (
    <div className="flex flex-col">
      {/* The illustration bakes in a white ground, so it sits on an explicit white
          tile — invisible in light mode, a clean card in dark. */}
      <ThemeIcon
        lightIcon={BwPlaceLight}
        darkIcon={BwPlaceDark}
        className="h-32 w-32 shrink-0 mx-auto md:mx-0"
        aria-hidden
      />
      <h1 className="mt-8 text-3xl leading-9 font-semibold text-text-dark-max">
        Welcome home
      </h1>
      <p className="mt-2 text-base leading-normal text-text-dark-high text-pretty">
        {view.firstName ? `${view.firstName}, thank` : "Thank"} you for trusting
        us with your home. We begin servicing your area on{" "}
        {formatLaunchDate(view.campaign.launchDate)}.
      </p>

      {/* The same founders row the onboarding welcome step shows. */}
      <div className="mt-8 flex items-center gap-3">
        <BwFounderAvatarGroup
          className="h-11 w-[100px] shrink-0 object-contain"
          aria-hidden
        />
        <div>
          <p className="text-sm leading-5 font-medium text-text-dark-max">
            {PRESALE_FOUNDERS.names}
          </p>
          <p className="text-sm font-normal text-text-dark-high">
            {PRESALE_FOUNDERS.role}
          </p>
        </div>
      </div>

      <div className="mt-8">
        <Button size="xl" onClick={onReferClick}>
          Refer a neighbor
        </Button>
      </div>
    </div>
  );
}
